import React from "react";

import Span from "../Span";
import * as Styled from "./styles";

interface IUserDetailsProps {
  name: string;
  email: string;
  position: string;
}

const UserDetails: React.FC<IUserDetailsProps> = ({ name, email, position }) => (
  <Styled.Container>
    <Span>{name}</Span>
    <Span>{position}</Span>
    <Span>{email}</Span>
  </Styled.Container>
);

export default UserDetails;